export default __webpack_public_path__ + "static/media/close.99ffc316.svg";